import GridLayout from 'react-grid-layout';
import React from 'react';
import './ContentScheduler.css';
import { Popover, TimePicker, Select, Row, Col } from 'antd';

const { RangePicker } = TimePicker;
const { Option } = Select;

const pallette = ["#fc5c65", "#fd9644", "#fed330", "#26de81", "#2bcbba"]
const totalRows = 7;
const rowHeight = 80;
const totoWidth = 2000;


const hovercontent = (
    <div>
        Campaign Info
    </div>
)
const clickcontent = (
    <div>
        <span>Days to Activate</span>
        <Select
            mode="multiple"
            style={{ width: '100%' }}
            placeholder="Days to Activate"
            defaultValue={['0', '1', '2', '3', '4', '5', '6']}
            optionLabelProp="label"
        >
            <Option value="0" label="Sun">
                <div className="demo-option-label-item">
                    Sunday
                </div>
            </Option>
            <Option value="1" label="Mon">
                <div className="demo-option-label-item">
                    Monday
      </div>
            </Option>
            <Option value="2" label="Tues">
                <div className="demo-option-label-item">
                    Tuesday
      </div>
            </Option>
            <Option value="3" label="Wed">
                <div className="demo-option-label-item">
                    Wednesday
      </div>
            </Option>
            <Option value="4" label="Thu">
                <div className="demo-option-label-item">
                    Thursday
      </div>
            </Option>
            <Option value="5" label="Fri">
                <div className="demo-option-label-item">
                    Friday
      </div>
            </Option>
            <Option value="6" label="Sat">
                <div className="demo-option-label-item">
                    Saturday
      </div>
            </Option>
        </Select>
        <span>Time to Activate</span>
        <div>
            <RangePicker />
        </div>
    </div>
);

class MyFirstGrid extends React.Component {

    getRandomColor = () => {
        const randomElement = pallette[Math.floor(Math.random() * pallette.length)];
        return randomElement
    }
    getColor = (index) => {
        return pallette[index]
    }

    render() {
        const renderBGs = () => {
            var ele = [];
            for (var i = 0; i < totalRows; i++) {
                ele.push(
                    <div style={{ height: rowHeight, width: "100%", margin: "5px", padding: "3px" }}>
                        <div style={{ borderRadius: "8px", backgroundColor: "#f0f0f0", boxShadow: "1px 1px 5px #ccc", height: "100%", width: "100%" }}></div>
                    </div>
                )
            }

            return ele;
        }
        return (
            <div style={{ position: "relative", padding: "10px" }}>
                <GridLayout isBounded={true} margin={[5, 5]} autoSize={false} verticalCompact={false} preventCollision={true} className="layout" style={{ position: "absolute", height: rowHeight * totalRows, zIndex: 500 }} resizeHandles={["e"]} cols={1440} rowHeight={rowHeight} width={4000}>

                    <div key="a" data-grid={{ x: 0, y: 0, w: 20, h: 1 }} style={{ backgroundColor: this.getColor(0), boxShadow: "1px 1px 5px #888", borderRadius: "8px", padding: "3px", overflow: "hidden" }}>
                        <Popover placement="top" content={clickcontent} title="Content Active Time" trigger="click">
                            <div style={{ width: "100%", height: "100%" }}>
                                <h4>CAMPAIGN1</h4>
                                <p>10:00 a.m. - 18:30 p.m.</p>
                            </div>
                        </Popover></div>
                    <div key="b" data-grid={{ x: 20.5, y: 0, w: 50, h: 1 }} style={{ backgroundColor: this.getColor(2), boxShadow: "1px 1px 5px #888", borderRadius: "8px", padding: "3px", overflow: "hidden" }}>
                        <Popover placement="top" content={clickcontent} title="Content Active Time" trigger="click">
                            <div style={{ width: "100%", height: "100%" }}>
                                <h4>CAMPAIGN2</h4>
                                <p>10:00 a.m. - 18:30 p.m.</p>
                            </div>
                        </Popover>
                    </div>
                    <div key="c" data-grid={{ x: 70, y: 0, w: 30, h: 1 }} style={{ backgroundColor: this.getColor(4), boxShadow: "1px 1px 5px #888", borderRadius: "8px", padding: "3px", overflow: "hidden" }}>
                        <Popover placement="top" content={clickcontent} title="Content Active Time" trigger="click">
                            <div style={{ width: "100%", height: "100%" }}>
                                <h4>CAMPAIGN3</h4>
                                <p>10:00 a.m. - 18:30 p.m.</p>
                            </div>
                        </Popover>
                    </div>
                </GridLayout >
                <div style={{ position: "absolute", width: totoWidth, height: rowHeight * totalRows, zIndex: 0 }}>
                    {renderBGs()}
                </div>
            </div >
        )
    }
}

export default MyFirstGrid